/**
 * Billing Cancel — /billing/cancel
 *
 * Shown when the user abandons the Stripe Checkout. Industry design system
 * (auth grammar): Z plate + wordmark over a centered blueprint card on the
 * light ground, uppercase heading, primary accent CTA back to /billing.
 */

import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const HEADING = 'var(--font-heading)';
const ACC = 'var(--color-accent)';
const ACC7 = 'var(--color-accent-700)';

export default function BillingCancel() {
  const navigate = useNavigate();
  return (
    <Box
      className="zb-industry"
      sx={{
        minHeight: '100dvh',
        background: 'var(--color-bg)',
        color: 'var(--color-text)',
        fontFamily: 'var(--font-body)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: '40px 24px',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
        <Box component="span" sx={{ display: 'grid', placeItems: 'center', width: 30, height: 30, border: '1.5px solid var(--color-text)', fontFamily: HEADING, fontSize: 15, fontWeight: 600 }}>
          Z
        </Box>
        <Box component="span" sx={{ fontFamily: HEADING, fontSize: 19, fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase' }}>
          Zulbot
        </Box>
      </Box>

      <Box
        className="blueprint"
        sx={{ width: '100%', maxWidth: 460, mt: 3, p: '26px', background: 'transparent', boxShadow: 'var(--ind-shadow-md)' }}
      >
        <i className="corner tl" /><i className="corner tr" /><i className="corner bl" /><i className="corner br" />
        <Box sx={{ fontFamily: HEADING, fontSize: 10, fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: ACC7 }}>
          Assinatura
        </Box>
        <Typography
          component="h1"
          sx={{ m: '8px 0 0', fontFamily: HEADING, fontSize: 26, fontWeight: 600, letterSpacing: '-0.01em', textTransform: 'uppercase' }}
        >
          Checkout cancelado
        </Typography>
        <Typography sx={{ m: '7px 0 0', fontSize: 13.5, lineHeight: 1.55, color: 'color-mix(in srgb, var(--color-text) 72%, transparent)' }}>
          Nenhuma cobrança foi realizada.
        </Typography>
        <Box
          component="button"
          type="button"
          onClick={() => navigate('/billing')}
          sx={{
            width: '100%',
            minHeight: 44,
            mt: '20px',
            border: `1px solid ${ACC}`,
            background: ACC,
            color: 'var(--color-bg)',
            fontFamily: HEADING,
            fontSize: 13,
            fontWeight: 600,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            borderRadius: 0,
            cursor: 'pointer',
            '&:hover': { background: 'var(--color-accent-600)', borderColor: 'var(--color-accent-600)' },
            '&:active': { background: ACC7 },
          }}
        >
          Voltar
        </Box>
      </Box>
    </Box>
  );
}
